var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`snackbar ${_vm.variation}`},[(_vm.icon)?_c('CustomIcon',{attrs:{"name":_vm.computedIcon}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }